import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import FormItem from 'components/FormFields/FormItem';
import Select from 'components/FormFields/Select';


const DateNavigationForm = ({ selectedDate, projects, calendarApi, toggleDateTip }) => {
  const currentDate = calendarApi.getDate();
  const currentYear = currentDate.getFullYear();
  const _currentMonth = currentDate.getMonth();

  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedProject, setSelectedProject] = useState('');


  const monthOptions = dayjs.months().map((month) => (
    { value: month.toLowerCase(), label: month }
  ));

  const yearOptions = Array.from(
    { length: 25 },
    (_, i) => currentYear - 12 + i,
  );

  const projectOptions = projects.map((project) => ({
    value: project.weddingDate,
    label: `${dayjs(project.weddingDate).format('MMM D, YYYY')} - ${project.name}`,
  }));

  function handleGoClick() {
    const month = selectedMonth;
    const year = selectedYear;
    const day = dayjs(selectedDate || currentDate).format('DD');
    const date = new Date(`${month} ${day} ${year}`);

    if (!date) return null;

    toggleDateTip();
    calendarApi.gotoDate(date);
  }

  function handleProjectSelect(e) {
    const projectDate = e.target.value;
    const date = new Date(projectDate);

    if (!date) return null;

    toggleDateTip();
    calendarApi.gotoDate(date);
    setSelectedProject(projectDate);
  }

  function handleMonthChange(e) {
    setSelectedMonth(e.target.value);
  }

  function handleYearChange(e) {
    setSelectedYear(e.target.value);
  }

  function handleGoToToday() {
    toggleDateTip();
    calendarApi.gotoDate(new Date());
  }

  useEffect(() => {
    if (currentYear && !selectedYear) {
      setSelectedYear(currentYear);
    }
  }, []);

  if (!selectedYear) {
    return null;
  }

  return (
    <div className="calendar-date-navigation-modal">
      <FormItem
        name='Skip to Date'
        labelProps={{
          className: 'calendar-date-navigation-modal__header',
        }}
      >
        <div className="calendar-date-navigation-modal__arbitrary">
          <Select
            className='month ng-pristine ng-valid'
            onChange={handleMonthChange}
            value={selectedMonth}
            emptyValue="Select"
          >
            {
              monthOptions.map((option, index) => (
                <option
                  key={option.value}
                  value={option.value}
                  selected={index === _currentMonth}
                >
                  {option.label}
                </option>
              ))
            }
          </Select>
          <Select
            type="text"
            className="year ng-pristine ng-valid"
            value={selectedYear}
            onChange={handleYearChange}
          >
            {
              yearOptions.map((year) => (
                <option
                  key={year}
                  value={year}
                  selected={year === currentYear}
                >
                  {year}
                </option>
              ))
            }
          </Select>
          <div className="calendar-confirm">
            <button
              type="button"
              className="button"
              onClick={handleGoClick}
            >
              Go
            </button>
          </div>
        </div>
      </FormItem>
      <FormItem
        name='Go to Project Date'
        labelProps={{
          className: 'calendar-date-navigation-modal__header',
        }}
      >
        <div className="calendar-date-navigation-modal__projects">
          <Select
            className='project ng-pristine ng-valid'
            value={selectedProject}
            onChange={handleProjectSelect}
            emptyValue="Select Project"
          >
            {
              projectOptions.map((option) => (
                <option
                  key={option.value}
                  value={option.value}
                >
                  {option.label}
                </option>
              ))
            }
          </Select>
        </div>
      </FormItem>
      <FormItem
        className='calendar-date-navigation-modal__footer'
      >
        <button
          type="button"
          className="button"
          onClick={handleGoToToday}
        >
          Go To Today
        </button>
      </FormItem>
    </div>
  );
};

export default DateNavigationForm;
